import React from 'react';

type CSVDownloadProps = {
}

export const CSVDownload: React.FC<CSVDownloadProps> = (props) => {

  return (
    <>
      <a id="download" href="#" download="sample"/>
    </>
  );
}

export const DownloadFile = (filename: string, content: Blob) => {
  let link = document.getElementById("download") as HTMLAnchorElement;
        
  if(link){
      link.href = URL.createObjectURL(content);
      link.download = filename;
      link.click();
  }
}
